import {abiturBall} from '@assets/js/helpers/functions';

export const mappingProfleBasic = (profileBasic) => {
    profileBasic.applicant_id = Number(profileBasic.applicant_id);
    profileBasic.gender_id = Number(profileBasic.gender_id);
    profileBasic.mailing_town_type_id = Number(profileBasic.mailing_town_type_id);
    profileBasic.mailing_region_id = Number(profileBasic.mailing_region_id);
    profileBasic.photo_file_id = Number(profileBasic.photo_file_id);
    profileBasic.scan_copy_snils_file_id = Number(profileBasic.scan_copy_snils_file_id);
    profileBasic.diploma_id = Number(profileBasic.diploma_id);
    return profileBasic;
};

export const mappingZajavls = (zajavls) => {
    return zajavls.map((zajavl) => {
        if (zajavl.status !== undefined) {
            zajavl.status = Number(zajavl.status);
        }
        // @todo убрать undefined после того как поле появится на сервере
        if (zajavl.is_need_hostel === undefined) {
            zajavl.is_need_hostel = 0;
        } else {
            zajavl.is_need_hostel = Number(zajavl.is_need_hostel);
        }
        if (zajavl.contests) {
            zajavl.contests = zajavl.contests.map((contest) => {
                contest.id = Number(contest.id);
                contest.edu_level_id = Number(contest.edu_level_id);
                contest.form = Number(contest.form);
                contest.source_id = Number(contest.source_id);
                contest.prior_zachislenia = !!contest.prior_zachislenia ? Number(contest.prior_zachislenia) : null;
                contest.requirement_id = Number(contest.requirement_id);
                contest.exams = mappingContestExams(contest.exams);
                return contest;
            });
        } else {
            zajavl.contests = [];
        }
        return zajavl;
    });
};

export const mappingContestExams = (contestExams) => {
    contestExams = contestExams.map((priority) => {
        priority.priority_id = Number(priority.priority_id);
        priority.exams.map((exam) => {
            exam.exam_id = Number(exam.exam_id);
            exam.type_rows = exam.type_rows.map((typeRow) => {
                return {id: Number(typeRow.id), type: Number(typeRow.type), min_ball: typeRow.min_ball};
            });
            return exam;
        });
        return priority;
    });
    return contestExams;
};

export const mappingExam = (row) => {
    return {
        ...row,
        id: Number(row.id),
    };
};

export const mappingExams = (list) => {
    const listMapped = list.map((row) => {
        return mappingExam(row);
    });
    listMapped.unshift({id: 0, name: 'Не выбрано', name_en: 'Not selected'});
    return listMapped;
};

export const mappingApplicantExam = (row) => {
    return {
        ...row,
        id: Number(row.id),
        exam_id: Number(row.exam_id),
        type: Number(row.type),
        ball: abiturBall(row.ball),
        admissions_committee_ball: abiturBall(row.admissions_committee_ball),
    };
};

export const mappingApplicantExams = (list) => {
    return list.map((row) => {
        return mappingApplicantExam(row);
    });
};

export const mappingSprCompetitionsZajavls = (list) => {
    return list.map((row) => {
        return {
            competition_group_id: Number(row.competition_group_id),
            edu_level: Number(row.edu_level),
            for_foreign_citizens: Number(row.for_foreign_citizens),
            form_id: Number(row.form_id),
            id: Number(row.id),
            level_budget_id: Number(row.level_budget_id),
            requirement_id: Number(row.requirement_id),
            source_id: Number(row.source_id),
            prior_zachislenia: !!row.prior_zachislenia ? Number(row.prior_zachislenia) : null,
            is_based_prof_education: Number(row.is_based_prof_education),
        };
    });
};

export const mappingSettings = (settings) => {
    return {
        ...settings,
        is_required_photo: Number(settings.is_required_photo),
        is_required_scan_copy_snils: Number(settings.is_required_scan_copy_snils),
        count_zajavl_allowed_in_campaign: Number(settings.count_zajavl_allowed_in_campaign),
        is_show_section_ege_results: Number(settings.is_show_section_ege_results),
        is_show_section_ege_documents: Number(settings.is_show_section_ege_documents),
        is_show_section_privileges: Number(settings.is_show_section_privileges),
    };
};

export const mappingRatingApplicantsLinks = (links) => {
    return links.map((row) => {
        return {
            ...row,
            id: Number(row.id),
        };
    });
};
